module.exports = __webpack_public_path__ + "static/media/rooms-menu-active-icon.8f2b8e65.svg";